/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

// $("#shopify-section-1543997898481 .SectionHeader__Heading").html(function(){
//   var text= $(this).text().trim().split(" ");
//   var first = text.shift();
//   return (text.length > 0 ? "<span class='SectionHeader__Heading--first-word'>"+ first + "</span> " : first) + text.join(" ");
// });


$("#shopify-section-1543997898481 .SectionHeader__Heading, .pageContent__Contact-column .SectionHeader__Heading").html(function(){
  var text= $(this).text().trim().split(" ");
  var last = text.pop();
  return text.join(" ") + (text.length > 0 ? " <span class='SectionHeader__Heading--last-word'>" + last + "</span>" : last);
});



$(document).ready(function() {
    if(window.location.pathname.match('contact')){
        $("body").addClass("template-contact");
    }
  $('#shopify-section-1563510138559 .SectionHeader__Heading').each(function(index, element) {
      var heading = $(element);
      var word_array, last_word, first_part;

      word_array = heading.html().split(/\s+/); // split on spaces
      last_word = word_array.pop();             // pop the last word
      first_part = word_array.join(' ');        // rejoin the first words together

      heading.html([first_part, ' <span class="SectionHeader__Heading--last-word">', last_word, '</span>'].join(''));
  });

  $('.js-popout-site-playlist').click(function() {
    var playlist = $(this).data("playlist");
    window.open(playlist, "Six60Player", "width=600,height=600,scrollbars=no");
  });

  $("[data-action='scroll-to-cart-note']").click(function() {
    $([document.documentElement, document.body]).animate({
        scrollTop: $("#cart-note").offset().top
    }, 600);
    $("#cart-note").focus();
  });

});




$(function () {
   $("#Promo__Song-js-step01").click(function () {
   	$(".ImageHero__Block").removeClass("Promo__Step01 ").addClass("Promo__Step02");
   });
});

/************************** button "add to cart" collection pages **************************/

$('.ad_to_cart_coll').click(function(){    
  var ID = $(this).attr("data-var_id");
  addItemToCart( ID, 1 );    // paste your id product number
  $('.cart_dr').trigger( "click" );
});


function addItemToCart(variant_id, qty) {
  data = {
    "id": variant_id,
    "quantity": qty
  }
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() {
      document.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: variant_id,
          quantity: qty
        }
      }))
    }
  });
}